function TextInput({ type, height, isEmail, value, onChange }) {
    const numericHeight = parseInt(height.split("-")[1], 10);
    const roundedClass = numericHeight < 20 ? "rounded-[20px]" : "rounded-[20px]";

    return(
        !isEmail ? (
            <div>
                <textarea
                    className={`
                        w-full
                        bg-transparent
                        border-2
                        border-white/60
                        ${roundedClass}
                        ${height}
                        px-4
                        py-3
                        text-white
                        placeholder-white/60
                        resize-none
                        focus:outline-none
                        focus:ring-2
                        focus:ring-white/50
                        focus:border-white/80
                        transition-all
                        duration-200
                        backdrop-blur-sm
                        overflow-hidden
                    `}
                    placeholder={type ? `${type}`: "Enter text"}
                    value={value}
                    onChange={onChange}
                />
            </div>
        ) : (
            <input
                type="email"
                className={`
                    w-full
                    bg-transparent
                    border-2
                    border-white/60
                    ${roundedClass}
                    ${height}
                    px-4
                    py-3
                    text-white
                    placeholder-white/60
                    focus:outline-none
                    focus:ring-2
                    focus:ring-white/50
                    focus:border-white/80
                    transition-all
                    duration-200
                    backdrop-blur-sm
                `}
                placeholder={type ? `${type}` : "Enter email"}
                value={value}
                onChange={onChange}
                required
            />
        )
    );
}

export default TextInput;